export default {"src":"/_next/static/image/public/images/flags/flag_375.cb24143705d493f3146bcdb52a327305.svg","height":16,"width":25};